<div class="organization-modal modal-content" piqetAngularDraggable>
  <ng-container>
    <div class="modal-header header-modal">
      <span class="bootstrap-dialog-title header-title">{{ modalLabel }}</span>
      <button type="button" aria-label="Close" class="closeModal pull-right" (click)="onClose()">
        <img src="./assets/icons/pop-up-cross.svg" width="16" height="17" />
      </button>
    </div>

    <div class="modal-body body-modal">
      <form [formGroup]="copyReportTemplateForm">
        <div class="row">
          <div class="col-12">
            <div class="form-group required" aria-required="true">
              <piqet-angular-common-input
                formControlName="templateName"
                [control]="copyReportTemplateForm.get('templateName')"
                label="Report name"
                placeholder="Report name"
                [maxLength]="255"
                [submitted]="submitted"
              >
              </piqet-angular-common-input>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="form-group required">
              <label
                *ngIf="copyReportTemplateForm.get('organization')?.value"
                class="sub-header-drpdown pb-2"
                >Organization</label
              >
              <ng-select
                [clearable]="true"
                [clearOnBackspace]="false"
                #organization
                [items]="organizationList"
                [searchable]="false"
                bindLabel="name"
                formControlName="organization"
                [searchFn]="commonInputSearch"
                placeholder="Select organization"
              >
                <ng-template ng-header-tmp>
                  <div class="has-feedback">
                    <input
                      type="text"
                      class="form-control accordion-search search-input"
                      placeholder="Search..."
                      (input)="organization.filter($any($event.target).value)"
                    />
                    <span class="form-control-feedback">
                      <i class="fa fa-search icon"></i>
                    </span>
                  </div>
                </ng-template>
                <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                  <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
                </ng-template>
              </ng-select>
              <div
                *ngIf="
                  (submitted && copyReportTemplateForm.controls['organization']?.invalid) ||
                  (copyReportTemplateForm.controls['organization']?.touched &&
                    copyReportTemplateForm.controls['organization']?.invalid)
                "
                class="input-error"
              >
                Organization is required.
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>

    <div class="modal-footer d-flex justify-content-start">
      <button type="button" class="btn btn-light cancelBtn" (click)="onClose()">Cancel</button>
      <button type="button" class="modelBtn" (click)="onSave()">Save</button>
    </div>
  </ng-container>
</div>
